module.exports = new __parcel__URL__("noResultsDark.90199792.svg").toString();